// @flow
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import PendingDeliveryPanel from './PendingDeliveryPanel';
import { dismissDeliveryResource } from '../../../modules/yourOrders';
import config from '../../../config';
import type { DispatchProps, FlaggedProps } from './PendingDeliveryPanel';

const mapDispatchToProps: DispatchProps = {
  dismissDeliveryResource,
};

const withFlaggedProps = (): FlaggedProps => ({
  displayDeliveryMethod: config.displayDeliveryMethodInPendingDeliveryPanel,
});

export default compose(connect(null, mapDispatchToProps), withProps(withFlaggedProps))(PendingDeliveryPanel);
